import { createInjectionKey } from "../../_utils/index.mjs";
export const tabsInjectionKey = createInjectionKey('n-tabs');